import React from "react";
import Radio from "@mui/material/Radio";
import StyledRadioChecked from "../StyledRadio/StyledRadioChecked/StyledRadioChecked";
import StyledRadioIcon from "../StyledRadio/StyledRadioIcon/StyledRadioIcon";

export default function PrimaryRadio(props) {
  return (
    <Radio
      sx={{
        "&:hover": {
          bgcolor: "transparent",
        },
      }}
      disableRipple
      color="default"
      checkedIcon={<StyledRadioChecked />}
      icon={<StyledRadioIcon />}
      {...props}
    />
  );
}